/**
 * A2 · La ruta con la que una pantalla se identifica ante los filtros guardados.
 * PURA.
 *
 * ⚠️ POR QUÉ EXISTE: la lista de conversaciones vive dentro de
 * `/conversations/:id`. Si se guardara contra `location.pathname` tal cual, cada
 * conversación abierta sería "otra pantalla": el filtro guardado con una charla
 * abierta no aparecería con otra, y el server además lo rechazaría por no
 * conocer `/conversations/abc123`.
 *
 * Lo mismo con `/clientes/:id`.
 *
 * Las ocho pantallas con filtros son todas de UN segmento, así que la regla es
 * simple y no hay que mantener una tabla: se corta en el primer segmento.
 */
export function rutaDePantalla(pathname: string): string {
  const primero = pathname.split('/').filter(Boolean)[0];
  return primero ? `/${primero}` : '/';
}
